import type { MarketingAction } from "src/types/action/MarketingAction";
import type { MarketingActionPos } from "src/types/action/MarketingActionPos";
import type { Channel, ChannelCategory } from "src/types/channel";
import type { CountryEnum } from "src/types/country";
import type { OfferScenario } from "src/types/offer/OfferScenario";
import type { IdName } from "./IdName";
import type { Pos } from "./pos";
import type { SponsoredAd } from "./sponsored-ads";

export enum ScenarioSpecificActivationEnum {
    Peak = "peak",
    FirstSlot = "firstSlot",
}

export interface Offer extends MarketingAction {
    id: number;
    posMarketingActions?: PosOffer[];
    performance?: {
        impact: OfferImpact;
        pastImpact: OfferPastImpact[];
        otherImpact: OfferPastImpact[];
    };
    duoMarketingActionId?: number;
    duoMarketingAction: SponsoredAd;
    durationStartFromMidnight: string;
    durationEndFromMidnight: string;
    mainScenario?: OfferScenario;
    scenarios: OfferScenario[];
    scenarioSpecificActivationPayload?: {
        peak?: number;
        firstSlot?: number;
    };
}

export interface PosOffer extends MarketingActionPos {
    id: number;
    createdDateUTC: Date;
    pos: Pos;
    posId: number;
    isActiveLink: boolean;
    unlinkedDateUTC: Date;
}

export interface OfferType {
    id: number;
    name: string;
    key: string;
    offerDiscounts: OfferDiscount[];
}

// Info: l'ordre dans la création de l'offre est dependant de l'ordre de cette enum
export enum OfferTypeEnum {
    Bogo = "bogo",
    FlatOff = "flat-off",
    DiscountByItem = "discount-by-item",
    SpecificDish = "specific-dish",
    FreeItem = "free-item",
    FreeDelivery = "free-delivery",
    FlatDelivery = "flat-delivery",
}

export interface OfferAudience extends IdName {
    categoryDiscounts: {
        category: ChannelCategory;
        discounts: any[];
    }[];
}

export interface OfferRecurrence extends IdName {
    isWeekly: boolean;
}

export enum OfferRecurrenceEnum {
    Once = 1,
    AllDays = 2,
    AllWeekdays = 3,
    WeeklyDay = 4,
    Custom = 5,
}

export interface ChannelOfferDiscountAudienceCountry {
    id: number;
    channelId: number;
    channel: Channel;
    offerDiscountId?: number;
    offerDiscount?: OfferDiscount;
    offerAudienceId?: number;
    offerAudience?: OfferAudience;
    countryCode?: CountryEnum;
}

export interface OfferDiscount {
    id: number;
    name: string;
    percentDiscount?: number;
    flatDiscount?: number;
    minBasket?: number;
    campaignName?: string;
    specialOperationTitle?: string;
    maxItem: number;
    type: OfferTypeEnum;
    isEnabled: boolean;
    isSpecialDiscount: boolean;
    specialOperationSubTitle: string;
    specialOperationStartDate: string;
    specialOperationEndDate: string;
    specialOperationStartTime: string;
    specialOperationEndTime: string;
}

interface OfferImpact {
    basketCount: number;
    basketAverage: number;
    sales: number;
    marginCoeff: number;
    profit: number;
}

export interface OfferPastImpact {
    scope: string;
    basketCount: number;
    basketCountDiff: number;
    basketAverage: number;
    basketAverageDiff: number;
    sales: number;
    salesDiff: number;
    marginCoeff: number;
    marginCoeffDiff: number;
    profit: number;
    profitDiff: number;
}
